import { useState, useMemo } from 'react';

function getVal(item, key) {
  if (typeof key === 'function') return key(item);
  return key.split('.').reduce((o, k) => o?.[k], item);
}

function compareValues(a, b) {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  if (typeof a === 'string' && /^\d{4}-\d{2}-\d{2}/.test(a)) return new Date(a) - new Date(b);
  if (a instanceof Date) return a - b;
  return String(a).toLowerCase().localeCompare(String(b).toLowerCase());
}

// Pure utility — usable outside a hook context (e.g. inside IIFEs in JSX)
export function sortData(data, sortConfig) {
  if (!sortConfig || !data?.length) return data ?? [];
  return [...data].sort((a, b) => {
    const c = compareValues(getVal(a, sortConfig.key), getVal(b, sortConfig.key));
    return sortConfig.direction === 'asc' ? c : -c;
  });
}

export function useSortableTable(data, defaultSort = null) {
  const [sortConfig, setSortConfig] = useState(defaultSort);

  const sortedData = useMemo(() => sortData(data, sortConfig), [data, sortConfig]);

  function requestSort(key) {
    setSortConfig(prev =>
      prev?.key === key && prev.direction === 'asc'
        ? { key, direction: 'desc' }
        : { key, direction: 'asc' }
    );
  }

  function getSortClass(key) {
    if (!sortConfig || sortConfig.key !== key) return 'sortable-th';
    return `sortable-th sort-${sortConfig.direction}`;
  }

  return { sortedData, sortConfig, requestSort, getSortClass };
}
